@if (assistanceBundle$ | async; as assistanceBundle) {
  <ion-header>
    <ion-toolbar>
      <ion-grid>
        <ion-row>
          <ion-col sizeLg="8" size="12">
            <ion-title id="title">
              @if (assistanceBundle.selectedAssistance?.isBilled) {
                <ion-icon name="lock-closed" color="danger" id="lock"></ion-icon>
              }
              <div class="title-wrapper">
                @if (assistanceBundle.selectedAssistance) {
                  <span id="title-text" (click)="goToClient(assistanceBundle.selectedAssistance.clientId)">
                    Asistence
                    @if (assistanceBundle.selectedAssistance.clientName) {
                      : {{ assistanceBundle.selectedAssistance.clientName }}
                    }
                  </span>
                }
                @if (userService.isCurrentUserSuperadmin() | async) {
                  <span class="title-superadmin">
                    @if (assistanceBundle.selectedAssistance?.id) {
                      <span>, ID: {{ assistanceBundle.selectedAssistance?.id }}</span>
                    }
                    @if (assistanceBundle.selectedAssistance?.recurrenceParentId) {
                      <span>, recurrenceParentID: {{ assistanceBundle.selectedAssistance?.recurrenceParentId }}</span>
                    }
                    @if (assistanceBundle.selectedAssistance?.bundleParentId) {
                      <span>, bundleParentId: {{ assistanceBundle.selectedAssistance?.bundleParentId }}</span>
                    }
                    @if (assistanceBundle.selectedAssistance?.allocationId) {
                      <span>, allocationId: {{ assistanceBundle.selectedAssistance?.allocationId }}</span>
                    }
                  </span>
                }
              </div>
            </ion-title>
          </ion-col>
          <ion-col sizeLg="4" size="12" class="modeSubtitle" data-cy="recurrenceMode">
            Režim úprav:
            {{ humanizedRecurrenceEditingMode }}
          </ion-col>
        </ion-row>
      </ion-grid>
      <ion-buttons slot="end">
        <ion-button (click)="tryClose()" data-cy="closeBtn">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    @if (assistanceBundle.main.isGroupSession) {
      <ion-card>
        <ion-card-content>
          <app-group-session-editor
            [bundle]="assistanceBundle"
            [recurrenceEditingMode]="recurrenceEditingMode"
            [editableHandler]="editableStateHandler"
            (reloadBundle)="forceReloadBundle($event)"
            (notifyURIDChange)="onURIDChange($event)"
            (bundleChildAssistanceDeleted)="bundleChildAssistanceDeleted(assistanceBundle, $event)"
            (recurrenceEditingModeChange)="recurrenceEditingModeChanged($event)"
          ></app-group-session-editor>
        </ion-card-content>
      </ion-card>
    } @else {
      <ion-card>
        @if (bundleChildAssistancesEnabled && assistanceBundle.main) {
          <ion-card-header>
            <ion-segment
              #segmentButton
              [ngModel]="selectedBundleSegment"
              (ionChange)="segmentChanged($event, assistanceBundle)"
              [disabled]="!isBundleNavigEnabled()"
            >
              @if (assistanceBundle) {
                @for (a of assistanceBundle.all; track a; let i = $index) {
                  <ion-segment-button [value]="i.toString()" class="bundle-navig-assistance-{{ i }}">
                    <ion-label>
                      @if (!!i) {
                        <span class="circular">+{{ i }}</span>
                      }
                      {{ a.plannedFrom | date: 'HH:mm' }}-{{ a.plannedTo | date: 'HH:mm' }}
                    </ion-label>
                  </ion-segment-button>
                }
              }
              <ion-segment-button
                (click)="bundleChildAssistanceAddBtnClicked(assistanceBundle)"
                [value]="BUNDLE_SEGMENT_ADD"
                [disabled]="
                  isCreateMode(assistanceBundle) ||
                  assistanceBundle.main.isExpanded() ||
                  assistanceBundle.main.isRecurrentButNotException() ||
                  (assistanceEditorModalService.editorPreventAddBundleChild$ | async)
                "
                class="bundle-navig-assistance-add"
                data-cy="addBundleChild"
              >
                <ion-icon name="add"></ion-icon>
              </ion-segment-button>
            </ion-segment>
          </ion-card-header>
        }
        @if (assistanceBundle) {
          <ion-card-content>
            <div id="bundledAssistancesWrapper">
              <app-assistance-editor
                [assistance]="assistanceBundle.selectedAssistance"
                [recurrenceEditingMode]="recurrenceEditingMode"
                [isInBundle]="!!assistanceBundle.children.length"
                [editableHandler]="editableStateHandler"
                (bundleChildAssistanceDeleted)="bundleChildAssistanceDeleted(assistanceBundle, $event)"
                (recurrenceEditingModeChange)="recurrenceEditingModeChanged($event)"
                (notifyURIDChange)="onURIDChange($event)"
              ></app-assistance-editor>
            </div>
          </ion-card-content>
        }
      </ion-card>
    }
  </ion-content>
}
